import React, { FC } from 'react'
import Switch from 'react-switch'
import { Container, TextStyled } from './Toggle.styles'

interface ToggleProps {
  checked: boolean
  setChecked: (input: boolean) => void
}

const Toggle: FC<ToggleProps> = ({ checked, setChecked }) => {
  return (
    <Container>
      <TextStyled>Refresh</TextStyled>
      <Switch onChange={setChecked} checked={checked} />
    </Container>
  )
}
export default Toggle
